// ErrorPage.tsx
import { useRouteError } from 'react-router-dom';
import { Box, Heading, Text, Button, VStack, Flex } from '@chakra-ui/react';
import { MailToLink } from './components/Submission/MailToLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';

export default function ErrorPage() {
  const error: any = useRouteError();
  const refreshPage = () => {
    window.location.reload();
  };

  const goToHome = () => {
    window.location.href = '/';
  };
  return (
    <Box
      minH="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      px={4}
      backgroundColor="surfaceSecondaryFill"
    >
      <Box w="100%" p={12} borderRadius="md" textAlign="center">
        <VStack spacing={6}>
          <Box>
            <FontAwesomeIcon fontSize={'7rem'} icon={faTriangleExclamation} />
          </Box>
          <Heading size="xl">Whoops, something went wrong.</Heading>{' '}
          <Text fontSize="md">
            unexpected errors may happen while we improve the platform
          </Text>
          <Text fontSize="md">Error : {error.message}</Text>{' '}
          <Flex gap={4}>
            <Button
              onClick={refreshPage}
              variant={'secondary'}
              size="md"
              px={8}
            >
              Refresh
            </Button>
            <Button onClick={goToHome} variant="primary" size="md" px={8}>
              Go home
            </Button>
          </Flex>{' '}
          <Text fontSize="md">
            If the issue persists, please contact us at <MailToLink />
          </Text>
        </VStack>
      </Box>
    </Box>
  );
}
